// removed by extract-text-webpack-plugin
module.exports = {"colorIcon":"_2Xzg6 CO6xt","emojiIcon":"BdMvi rTQr-","icon":"_2ztzj _2rmlO"};


//////////////////
// WEBPACK FOOTER
// ./components/LabelIcon.css
// module id = 1991
// module chunks = 3